import { CSS, StyleProps } from "@shared/primitive-components"

export const container = () => ({
  Flex: 1,
  width: `100%`,
})

export const marginBottom = (props: StyleProps) => ({
  marginBottom: props.theme.spacing(6),
})

export const marginLeft = (props: StyleProps) => ({
  marginLeft: props.theme.spacing(4),
})

export const filterButtons = (props: StyleProps) => ({
  margin: props.theme.spacing(0),
  marginLeft: `auto`,
})

export const addButton = (props: StyleProps) => ({
  margin: props.theme.spacing(0, 4),
})

export const editButton = (props: StyleProps) => ({
  marginLeft: props.theme.spacing(4),
})

export const noMarginBottom = (): CSS => ({
  marginBottom: 0,
})

export const checkboxContainer = (): CSS => ({
  flexDirection: `column`,
  alignItems: `center`,
  width: `100%`,
})

export const highlightRow = (): CSS => ({
  background: `rgba(0, 0, 0, 0.04)`,
})
